import React, { Component } from 'react';
import PropTypes from 'prop-types'
import * as types from '../../constants/actionTypes';
import Drawer from '../Common/Drawer/Drawer';
import Icon from '../Common/Icon';
import LoadingIndicator from '../Common/LoadingIndicator/LoadingIndicator';
import Notification from '../Common/Notification';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';

export default class OrderTasksDrawer extends Component {

    constructor(props, context) {
        super(props, context);

        this.state = {
            isFormValid: true,
            isLoading: false,
            tasks: []
        }
    }

    async componentDidMount() {
        await this.loadFilters();
    }

    loadFilters = async () => {
        try {
            this.setState({ isLoading: true });
            const request = {
                subscrptionId: this.props.subscriptionId,
                baselineId: this.props.baselineId,
                targetDaysOut: this.props.targetDaysOut,
                targetStaticDate: this.props.targetStaticDate,
                isActive : true
            }
            const response = await this.props.baselineTaskActions.loadOrderTasksFilters(request);
            if (response.type === types.LOAD_ORDER_BASELINE_TASKS_FILTERS_SUCCESS) {
                this.setState({
                    isLoading: false,
                    tasks: response.payload.baselineTasks
                });
            } else if (response.type === types.LOAD_ORDER_BASELINE_TASKS_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        }
    }

    onDragEnd = (result) => {
        // dropped outside the step list area
        if (!result.destination) {
            return;
        }

        const tasks = this.state.tasks.slice();
        const [removed] = tasks.splice(result.source.index, 1);
        tasks.splice(result.destination.index, 0, removed);

        /**
         * Always update the entire list, so the sameDayOrdinal is always 0 - n
         * We don't know if they're all zero because v4 has known bugs with negatives and other weirdness.
         * Hopefully this ensures any reordering is done properly with 0 - n values all the time.
         */ 
        for (let i = 0; i < tasks.length; i++) {
            tasks[i].sameDayOrdinal = i;
        }
        this.setState({ tasks: tasks });
    }

    onSave = async () => {
        try {
            this.setState({ isLoading: true });
            const request = {
                subscrptionId: this.props.subscriptionId,
                baselineId: this.props.baselineId,
                targetDaysOut: this.props.targetDaysOut,
                targetStaticDate: this.props.targetStaticDate,
                baselineTasks: this.state.tasks
            };
            const response = await this.props.baselineTaskActions.orderBaselineTasks(request);
            if (response.type === types.ORDER_BASELINE_TASKS_SUCCESS) {
                Notification("success", "Success", "Baseline Task order saved successfully");
                this.props.onComplete();
            } else if (response.type === types.ORDER_BASELINE_TASKS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
                this.setState({ isLoading: false });
            }
        } catch (error) {
            Notification("error", "Error", error);
            this.setState({ isLoading: false });
        }
    }

    render() {

        // tried moving this to scss but it just gets overridden from within the component
        const getItemStyle = (isDragging, draggableStyle) => ({
            userSelect: 'none',
            lineHeight: 1,
            margin: `0 0 8px 0`,
            background: 'white',
            border: isDragging ? '2px solid #03a9f4' : '',
            // styles we need to apply on draggables
            ...draggableStyle,
        });

        const getListStyle = isDraggingOver => ({
            background: isDraggingOver ? '#eee' : 'white',
            borderRadius: '0.25rem',
            padding: 8,
        });

        return (
            <div className="order-tasks-drawer">
                <Drawer isWide={true} title='Order Tasks' onCancelClick={this.props.onCancel} onSaveClick={this.onSave}>
                    <LoadingIndicator isLoading={this.state.isLoading}>
                        <div className="preamble">
                            <a href="https://ehsolution.zendesk.com/hc/en-us/articles/360016068954-How-to-Order-Tasks" rel="noopener noreferrer" target="_blank">Click here for task ordering help documentation.</a>
                        </div>

                        <DragDropContext onDragEnd={this.onDragEnd}>
                            <Droppable droppableId="droppable">
                                {(provided, snapshot) => (
                                    <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)}>
                                        {
                                            this.state.tasks.map((task, index) => (
                                                <Draggable key={task.id} draggableId={task.id.toString()} index={index}>
                                                    {(provided, snapshot) => (
                                                        <div className="task row" ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps} style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                            <div className="col-1">
                                                                <div className="bars">
                                                                    <Icon name="bars" />
                                                                </div>
                                                            </div>
                                                            <div className="col-11 task-name pt-2">
                                                                {task.name}
                                                            </div>
                                                        </div>
                                                    )}
                                                </Draggable>
                                            ))
                                        }
                                        {provided.placeholder}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>


                    </LoadingIndicator>
                </Drawer>
            </div>
        )
    }
}

OrderTasksDrawer.propTypes = {
    subscriptionId: PropTypes.string.isRequired,
    baselineId: PropTypes.string.isRequired,
    targetDaysOut: PropTypes.string.isRequired,
    targetStaticDate: PropTypes.string.isRequired,
    onComplete: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    baselineTaskActions: PropTypes.object.isRequired
};

